import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import RgInteraction from '../../components/ResponsibleGambling/RgInteraction/RgInteraction';

import {
  displayModal
} from '@xanadu/ui-shared/modules/modal/actions';

const mapDispatchToProps = {
  displayModal,
};

function mapStateToProps(state) {
  return {
    widthSize: state.getIn(['application', 'widthSize']),
    rgInteractionStatus: state.getIn(['user', 'rgInteractionStatus']),
    rgInteractionData: state.getIn(['user', 'rgInteractionData']),
    currency: state.getIn(['user', 'currency']),
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(RgInteraction));
